import { useSelector } from 'react-redux'

import { useTranslate, withComponents } from '../../utils/translate'

// Languages for which a label asset exists. Every current base shop language
// is covered; future storefront languages without a label fall back to English.
export const labelLanguages = ['ca', 'cs', 'da', 'de', 'en', 'es', 'fi', 'fr', 'it', 'nl', 'no', 'pt', 'ru', 'sv']

// The short localized EU vanity URLs exactly as printed on each label below
// the QR code. The Catalan label carries the Spanish URL, the Norwegian and
// Russian labels carry the English one.
export const officialEuPageUrls: Record<string, string> = {
  ca: 'https://europa.eu/youreurope/garantías',
  cs: 'https://europa.eu/youreurope/záruky_cs',
  da: 'https://europa.eu/youreurope/garantier',
  de: 'https://europa.eu/youreurope/garantien',
  en: 'https://europa.eu/youreurope/guarantees',
  es: 'https://europa.eu/youreurope/garantías',
  fi: 'https://europa.eu/youreurope/virhevastuu',
  fr: 'https://europa.eu/youreurope/garanties',
  it: 'https://europa.eu/youreurope/garanzie',
  nl: 'https://europa.eu/youreurope/garantie',
  no: 'https://europa.eu/youreurope/guarantees',
  pt: 'https://europa.eu/youreurope/garantias',
  ru: 'https://europa.eu/youreurope/guarantees',
  sv: 'https://europa.eu/youreurope/reklamationsrätt',
}

export function LegalGuaranteeNotice() {
  const t = useTranslate('shop')
  const shopLocale = useSelector<State, string>((state) => state.getIn(['shop', 'locale']))
  const hashedThemeAssets = useSelector<State, ImmutableMap>((state) => state.getIn(['view', 'hashedThemeAssets']))

  const language = shopLocale.split(/[_-]/)[0]
  const labelLanguage = labelLanguages.includes(language) ? language : 'en'

  return (
    <figure className="legal-guarantee-notice">
      <img
        src={`/static/assets/legal-guarantee-notice/${hashedThemeAssets.getIn([
          'legal-guarantee-notice',
          `LegalGuaranteeNotice_${labelLanguage.toUpperCase()}.webp`,
        ])}`}
        alt={t('components.legalGuaranteeNoticeComponent.label.alt')}
      />
      <figcaption>
        {withComponents(t)('components.legalGuaranteeNoticeComponent.moreInformationLink.label', {
          link: (
            <a href={officialEuPageUrls[labelLanguage]}>
              {t('components.legalGuaranteeNoticeComponent.moreInformationLink.linkText')}
            </a>
          ),
        })}
      </figcaption>
    </figure>
  )
}
